// extracted by mini-css-extract-plugin
export default {"heroContent":"HeroContent_heroContent__sXqjb"};